import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/inventory/products/$productId/_layout/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/inventory/products/$productId/transactions",
      params: { productId: params.productId },
    })
  },
})
